// extracted by mini-css-extract-plugin
export default {"cls1":"CHNnFw5paarOU6Jg8ho0","cls2":"PxiOGOrhrWxkyZHrDMLQ CHNnFw5paarOU6Jg8ho0","isDesktopUp":"XkFa3P_gdlaC_x3TVsS6"};